export const DASHBOARD_DEFAULT = "DASHBOARD_DEFAULT";
export const DASHBOARD_WIZARD = "DASHBOARD_WIZARD";
export const PUBLIC_WIZARD = "PUBLIC_WIZARD";
